import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import PermitServices from "services/PermitServices";
import { notifyError, notifySuccess } from "utils/toast";
import VehicleCategoryServices from "services/VehicleCategoryServices";
const usePermitSubmit = (id) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFromState, setSelectedFromState] = useState(null);
  const [selectedEndState, setSelectedEndState] = useState(null);
  const [dataInput, setDataInput] = useState([
    { vehicle_type_names_0: "", permit_0: "" },
  ]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleVehicleCategoryChange = (e, index) => {
    const { name, value } = e.target;
    const updatedInput = [...dataInput];
    updatedInput[index][name] = value;
    setDataInput(updatedInput);

    const updatedOptions = [...selectedOptions];
    updatedOptions[index] = value;
    setSelectedOptions(updatedOptions);
  };

  const {
    trigger,
    register,
    handleSubmit,
    clearErrors,
    formState: { errors },
  } = useForm();

  const handleStateChange = (state, type) => {
    if (type === "from") {
      setSelectedFromState(state);
    } else if (type === "to") {
      setSelectedEndState(state);
    }
  };
  const handleChangeInput = (e, i) => {
    const { name, value } = e.target;
    const updatedInput = [...dataInput];
    updatedInput[i][name] = value;
    setDataInput(updatedInput);
  };

  const setDefaultVehicleData = (vehicles) => {
    const defaultData = vehicles.map((vehicle, index) => ({
      [`vehicle_type_names_${index}`]: String(vehicle.id),
      [`vehicle_type_name_${index}`]: vehicle.vehicle_type_name,
      [`permit_${index}`]: "0",
    }));

    setDataInput(defaultData);

    setSelectedOptions(vehicles.map((vehicle) => String(vehicle.id)));
  };

  const getVehicleCategories = async () => {
    try {
      const response = await VehicleCategoryServices.getAllVehicleCategory();

      const vehicles = Array.isArray(response?.data) ? response.data : [];

      setVehicleOptions(vehicles);

      return vehicles;
    } catch (err) {
      notifyError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to load vehicle categories",
      );

      return [];
    }
  };

  const onSubmit = async () => {
    setLoading(true);
    try {
      const vehicleTypeValues = dataInput.map((item, index) =>
        parseInt(item[`vehicle_type_names_${index}`]),
      );

      const permitValues = dataInput.reduce((acc, item, index) => {
        const vehicleId = item[`vehicle_type_names_${index}`];
        const permitValue = item[`permit_${index}`];

        acc[vehicleId] = permitValue || "0";

        return acc;
      }, {});

      const dataValues = {
        vehicle_type: vehicleTypeValues,
        permit: permitValues,
        from_state: selectedFromState,
        to_state: selectedEndState,
      };

      setIsSubmitting(true);
      if (id) {
        const res = await PermitServices.updatePermit(id, dataValues);
        setIsUpdate(true);
        notifySuccess(res.message);
      } else {
        const res = await PermitServices.addPermit(dataValues);
        setIsUpdate(true);
        notifySuccess(res.message);
      }
      setIsSubmitting(false);
      closeDrawer();
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
      setIsSubmitting(false);
      // closeDrawer();
    } finally {
      setLoading(false);
    }
  };

  // const getPermitData = async () => {
  //   try {
  //     const res = await PermitServices.getPermitById(id);
  //     if (res) {
  //       const FormWholeArray = res.vehicle_type_id.map((item, index) => ({
  //         [`vehicle_type_names_${index}`]: item,
  //         [`permit_${index}`]: res.permit[item],
  //       }));

  //       setDataInput(FormWholeArray);
  //       setSelectedOptions(res.vehicle_type_id);
  //       setSelectedFromState(res.from_state);
  //       setSelectedEndState(res.to_state);
  //     }
  //   } catch (err) {
  //     notifyError(err?.response?.data?.message || err?.message);
  //   }
  // };

  // useEffect(() => {
  //   if (!isDrawerOpen) {
  //     setDataInput([{ vehicle_type_names_0: "", permit_0: "" }]);
  //     setSelectedOptions([]);
  //     setSelectedFromState(null);
  //     setSelectedEndState(null);
  //     clearErrors();
  //     return;
  //   }

  //   if (id) {
  //     getPermitData();
  //   }
  //   // eslint-disable-next-line
  // }, [id, isDrawerOpen, clearErrors]);

  const getPermitData = async (vehicles) => {
    try {
      const res = await PermitServices.getPermitById(id);

      if (res) {
        const existingVehicleIds =
          res.vehicle_type_id?.map((item) => String(item)) || [];

        const FormWholeArray = vehicles.map((vehicle, index) => {
          const vehicleId = String(vehicle.id);

          const permitValue = res.permit?.[vehicleId];

          return {
            [`vehicle_type_names_${index}`]: vehicleId,

            [`vehicle_type_name_${index}`]: vehicle.vehicle_type_name,

            [`permit_${index}`]:
              existingVehicleIds.includes(vehicleId) &&
              permitValue !== undefined &&
              permitValue !== null &&
              permitValue !== ""
                ? String(permitValue)
                : "0",
          };
        });

        setDataInput(FormWholeArray);

        // All current backend vehicles are selected
        setSelectedOptions(vehicles.map((vehicle) => String(vehicle.id)));

        setSelectedFromState(res.from_state);
        setSelectedEndState(res.to_state);
      }
    } catch (err) {
      notifyError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to load permit data",
      );
    }
  };
  useEffect(() => {
    const initializeForm = async () => {
      if (!isDrawerOpen) {
        setDataInput([]);
        setSelectedOptions([]);
        setSelectedFromState(null);
        setSelectedEndState(null);
        clearErrors();
        return;
      }

      const vehicles = await getVehicleCategories();

      if (id) {
        await getPermitData(vehicles);
      } else {
        setDefaultVehicleData(vehicles);
      }
    };

    initializeForm();

    // eslint-disable-next-line
  }, [id, isDrawerOpen, clearErrors]);

  return {
    register,
    handleSubmit,
    onSubmit,

    handleStateChange,
    trigger,
    errors,
    isSubmitting,
    handleVehicleCategoryChange,
    selectedOptions,
    setSelectedOptions,
    setDataInput,
    dataInput,
    handleChangeInput,
    selectedFromState,
    setSelectedFromState,
    selectedEndState,
    setSelectedEndState,
    loading,
    setLoading,
  };
};

export default usePermitSubmit;
